var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"HScrollbar",style:({ width: '100%', overflowX: 'auto' }),on:{"scroll":_vm.onTopToBottomScroll}},[_c('div',{ref:"innerHSCrollbar",style:({ display: 'block', width: '0px', height: '1px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }